import Backdrop from "components/global/Backdrop";
import Button from "components/global/Button";
import Spacer from "components/global/Spacer";
import styled from "styled-components";
import PlatformPhoto from "components/global/PlatformPhoto";
import ImgWrapper from "components/global/ImgWrapper";
import userIcon from "assets/icons/userIconWhite.svg";
import { showAlert } from "utils/utils";
import { useHistory } from "react-router-dom";

const Wrapper = styled(Backdrop)`
  z-index: 13;

  .card {
    width: 430px;
    background-color: var(--white);
    border-radius: 16px;
  }

  .content {
    padding: 48px;
  }

  .actionBtns {
    padding: 24px 48px 48px;
    gap: 24px;
    border-top: 1px solid #f2f3f7;
  }

  @media screen and (max-width: 768px) {
    .card {
      width: calc(100% - 48px);
    }

    .content {
      padding: 24px;
    }
  }
`;

const YoutubeWrapper = styled.div`
  display: flex;
  align-items: center;
  border-radius: 8px;
  height: 4.8rem;
  border: 0;
  position: relative;
  padding: 11px 12px;
  width: 100%;
  background-color: #fafafa;
`;

const YoutubeConnectModal = ({
  open,
  onClose,
  removeSocial,
  youtubeChannel,
  brandId,
}) => {
  const router = useHistory();

  const handleAdd = () => {
    showAlert({
      msg: "Youtube channel connected",
      type: "success",
    });
    onClose();
    router.push(`/dashboard/brands/${brandId}/edit/channels`);
  };

  const handleRemove = () => {
    removeSocial();
    onClose();
    router.push(`/dashboard/brands/${brandId}/edit/channels`);
  };

  return (
    <>
      <Wrapper
        className={`flexRow alignCenter justifyCenter ${open && "show"}`}
      >
        <div className="card">
          <div className="content">
            <p className="title-3">Add your YouTube Channel</p>

            <Spacer y={2} />

            <YoutubeWrapper className="spanFull">
              <PlatformPhoto>
                <ImgWrapper
                  size={3.6}
                  imgHeight={"100%"}
                  className="imgWrapper"
                >
                  <img
                    src={youtubeChannel?.page?.photo ?? userIcon}
                    alt="avi"
                  />
                </ImgWrapper>
              </PlatformPhoto>
              <Spacer x={1} />
              <div>
                <p className="l2 bold">{youtubeChannel?.page?.name}</p>
              </div>
            </YoutubeWrapper>
            <Spacer y={2} />
            <p className="textDescription colorBodyText">
              By submitting your videos to YouTube, you acknowledge that you
              agree to YouTube's{" "}
              <span className="colorPrimary underline">
                <a
                  href="https://www.youtube.com/t/terms"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="textDescription"
                >
                  Terms of Service
                </a>
              </span>{" "}
              and{" "}
              <span className="colorPrimary underline">
                <a
                  href="https://www.youtube.com/howyoutubeworks/policies/community-guidelines/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="textDescription"
                >
                  Community Guidelines
                </a>
              </span>
              . Please be sure not to violate others' copyright or privacy
              rights.{" "}
              <span className="colorPrimary underline">
                <a
                  href="https://postpaddy.com/pages/privacy-policy"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="textDescription"
                >
                  Learn more
                </a>
              </span>
              .
            </p>
            <Spacer y={2} />
            <p className="textDescription colorBodyText">
              PostPaddy will follow Google's rules for handling information we
              receive from their APIs{" "}
              <span className="colorPrimary underline ">
                <a
                  href="https://developers.google.com/terms/api-services-user-data-policy#additional_requirements_for_specific_api_scopes"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="textDescription"
                >
                  (Google API Services User Data Policy)
                </a>
              </span>
              , including their Limited Use requirements.
            </p>
          </div>
          <div className="flexRow justifyCenter fullWidth actionBtns">
            <Button
              text="Cancel"
              bg="var(--white)"
              color="var(--grey_1)"
              bd="var(--grey_10)"
              fullWidth
              onClick={handleRemove}
            />
            <Button
              fullWidth
              text="Add"
              bg="var(--secondary)"
              onClick={handleAdd}
            />
          </div>
        </div>
      </Wrapper>
    </>
  );
};

export default YoutubeConnectModal;
